//jacques-andre-editeur\proshop-v2\frontend\src\screens\admin\BookEditScreen.jsx
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Button, Container, Tabs, Tab } from 'react-bootstrap';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import {
  useGetBookDetailsByIdQuery,
  useUpdateBookMutation,
} from '../../slices/booksApiSlice';
import { useGetBooksCollectionsQuery } from '../../slices/booksCollectionsApiSlice';
import { useGetAllAuthorsQuery } from '../../slices/authorsApiSlice';
import ReactQuill from 'react-quill';



const BookEditScreen = () => {

  const navigate = useNavigate();
  const { id: bookId } = useParams();

// Récupération des détails du produit
const { data: book, isLoading, error, refetch } = useGetBookDetailsByIdQuery({
  bookId,
  isAdminSpace: true,
})
  

console.log('data: book : ', book)
console.log('bookId : ', bookId)

  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [author1, setAuthor1] = useState('');
  const [author1Id, setAuthor1Id] = useState('');
  const [author2, setAuthor2] = useState('');
  const [author2Id, setAuthor2Id] = useState('');
  const [translator, setTranslator] = useState('');
  const [translatorId, setTranslatorId] = useState('');
  const [language, setLanguage] = useState('');
  const [booksCollection, setBooksCollection] = useState('');
  const [booksCollectionId, setBooksCollectionId] = useState('');
  const [preface, setPreface] = useState('');
  const [illustrations, setIllustrations] = useState('');
  const [bonnepage, setBonnepage] = useState('');
  const [sommaire, setSommaire] = useState('');
  const [hauteur, setHauteur] = useState('');
  const [largeur, setLargeur] = useState('');
  const [poids, setPoids] = useState('');
  const [stock, setStock] = useState(10000);
  const [price, setPrice] = useState('');
  const [cover, setCover] = useState('');  
  const [previewUrl, setPreviewUrl] = useState(null);
  const [description, setDescription] = useState('');
  const [isbn, setIsbn] = useState('');
  const [publicationDate, setPublicationDate] = useState('');
  const [numeroEditeur, setNumeroEditeur] = useState('');
  const [nbPages, setNbPages] = useState('');
  const [catchphrase, setCatchphrase] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [inList, setInList] = useState(true);

// Récupération des collections de livres
const { data: booksCollections, isLoading: loadingBooksCollections } = useGetBooksCollectionsQuery({
    isAdminSpace: true,
    parPage:400,
  });
const booksCollectionsList = booksCollections?.booksCollections || [];

// Récupération de la liste des auteurs  
const [searchAuthorTerm, setSearchAuthorTerm] = useState('');
const { data: authors, isLoading: loadingAuthors } = useGetAllAuthorsQuery({
  keyword: searchAuthorTerm,
});
const authorsList = authors?.authors || [];

const [updateBook, { isLoading: loadingUpdate }] = useUpdateBookMutation();

useEffect(() => {
  if (book) {
    setTitle(book.title || '');
    setSubtitle(book.subtitle || '');
    setAuthor1(book.author1 ? `${book.author1.firstName} ${book.author1.lastName}` : '');
    setAuthor1Id(book.author1?._id || '');
    setAuthor2(book.author2 ? `${book.author2.firstName} ${book.author2.lastName}` : '');
    setAuthor2Id(book.author2?._id || '');
    setTranslator(book.translator ? `${book.translator.firstName} ${book.translator.lastName}` : '');
    setTranslatorId(book.translator?._id || '');
    setLanguage(book.language || '');
    setBooksCollection(book.booksCollection?._id || book.booksCollection || '');
    setBooksCollectionId(book.booksCollectionId || '');
    setPreface(book.preface || '');
    setIllustrations(book.illustrations || '');
    setBonnepage(book.bonnepage || '');
    setSommaire(book.sommaire || '');
    setHauteur(book.hauteur || '');
    setLargeur(book.largeur || '');
    setPoids(book.poids || '');
    setStock(book.stock ?? 10000); // nullish coalescing, car stock peut être 0
    setPrice(book.price || '');
    setCover(book.cover || '');
    setPreviewUrl(book.cover || null); // ou un champ séparé si nécessaire
    setDescription(book.description || '');
    setIsbn(book.isbn || '');
    setPublicationDate(book.publicationDate || '');
    setNumeroEditeur(book.numeroEditeur || '');
    setNbPages(book.nbPages || '');
    setCatchphrase(book.catchphrase || '');
    setIsVisible(book.isVisible ?? true);
    setInList(book.inList ?? true);
  }
}, [book]);

  
    
  const submitHandler = async (e) => {
    e.preventDefault();
  
    if (!booksCollection) {
      toast.error('Veuillez sélectionner une collection');
      return;
    }
    const isValidNumber = (val) => val !== '' && !isNaN(val);
    // Préparer les données dans un FormData pour inclure le fichier
    const formData = new FormData();
    formData.append('bookId', bookId);
    formData.append('title', title);
    formData.append('price', parseFloat(price));
    formData.append('description', description);
    formData.append('isbn', isbn);
    formData.append('publicationDate', publicationDate);
    formData.append('numeroEditeur', numeroEditeur);
    formData.append('catchphrase', catchphrase);
    formData.append('isVisible', isVisible);
    formData.append('booksCollection', booksCollection);
    formData.append('subtitle', subtitle);
    formData.append('author1', author1Id);
    formData.append('author2', author2Id);
    formData.append('translator', translatorId);
    formData.append('language', language);
    formData.append('preface', preface);
    formData.append('illustrations', illustrations);
    formData.append('bonnepage', bonnepage);
    formData.append('inList', inList);    
    if (isValidNumber(nbPages)) formData.append('nbPages', parseInt(nbPages, 10));
    if (isValidNumber(hauteur)) formData.append('hauteur', parseFloat(hauteur));
    if (isValidNumber(largeur)) formData.append('largeur', parseFloat(largeur));
    if (isValidNumber(poids)) formData.append('poids', parseFloat(poids));
    formData.append('sommaire', sommaire);
    // formData.append('nbPages', parseInt(nbPages, 10));
    // formData.append('hauteur', hauteur);
    // formData.append('largeur', largeur);
    // formData.append('poids', poids); 
  
    // Ajouter la cover si elle existe
    if (cover instanceof FormData) {
      formData.append('cover', cover.get('cover'));
    }  

    // Inspecter le contenu du FormData
    console.log('FormData contenu :');
    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value, '!!');
    }

    try {
      await updateBook(formData).unwrap();
      toast.success('Fiche modifiée avec succès');
      navigate('/admin/booklist');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };
  

  
  return (
    <Container>
      <div className="h1-adminContainer">
        <h1>Modifier la fiche d'un livre</h1>
      </div>
      {isLoading && <Loader />}
      <Form onSubmit={submitHandler}>
        <div className="bookProfile">
          <div className="coverColumn">     
          <div className="registerFile">
            {/* <Form.Group controlId='publicationDate'>
              <Form.Label>Date de publication</Form.Label>
              <Form.Control
                type='date'
                value={publicationDate}
                onChange={(e) => setPublicationDate(e.target.value)}
              ></Form.Control>
            </Form.Group> */}
            <div className="ligneInputsCoverContainer">
              <span>N°&nbsp;Éditeur&nbsp;:&nbsp;</span>
              <input 
                type='text' className='inputBook inputInCoverContainer' style={{ color: numeroEditeur ? '#222' : '#bb1122' }}
                placeholder='nombre' value={numeroEditeur} onChange={(e) => setNumeroEditeur(e.target.value)} title='N° éditeur'
                />
            </div>
            <Form.Group controlId='inList'>
              <Form.Check
                type='checkbox'
                label='Afficher dans la liste'
                checked={inList}
                onChange={(e) => setInList(e.target.checked)}
              />
            </Form.Group>

            <Form.Group controlId='isVisible'>
              <Form.Check
                type='checkbox'
                label='Visible'
                checked={isVisible}
                onChange={(e) => setIsVisible(e.target.checked)}
              ></Form.Check>
            </Form.Group>
          </div>
            <div className="bookProfileImgContainerInputs">
              
              {previewUrl && (
                <div style={{ marginTop: '1rem' }}>
                  <img
                    src={previewUrl}
                    alt='Aperçu de la couverture'
                    className="bookProfile-img" 
                  />
                </div>
              )}

              <Form.Group controlId='cover'>
                <Form.Control
                  type="text"
                  placeholder="URL actuelle de la couverture'"
                  value={cover}
                  disabled
                ></Form.Control>
                <Form.Control
                  type='file'
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const formData = new FormData();
                      formData.append('cover', file);

                      // Ajouter le fichier directement à l'état avant l'envoi
                      setCover(formData);
                      setPreviewUrl(URL.createObjectURL(file));
                    }
                  }}
                  style={{ color: cover ? '#222' : '#bb1122' }}
                ></Form.Control>
              </Form.Group>


              <div className="ligneInputsCoverContainer">
                <span>Prix (€) :&nbsp;</span>
                <input 
                  type='text' className='inputBook inputPrice' style={{ color: price ? '#222' : '#bb1122' }}
                  placeholder='nombre' value={price} onChange={(e) => setPrice(e.target.value)} title='price'
                  />
              </div>
              <div className="ligneInputsCoverContainer">
                <span>ISBN :&nbsp;</span>
                <input 
                  type='text' className='inputBook inputInCoverContainer' style={{ color: isbn ? '#222' : '#bb1122' }}
                  placeholder='nombre' value={isbn} onChange={(e) => setIsbn(e.target.value)} title='isbn'
                  />
              </div>

              <Form.Group controlId="booksCollection">
                <Form.Control
                  as="select"
                  value={booksCollection}
                  onChange={(e) => setBooksCollection(e.target.value)}
                  required
                  style={{ color: booksCollection ? '#333' : '#bb1122' }}
                >
                  <option value="">Sélectionner une collection</option>
                  {booksCollectionsList?.map((coll) => (
                    <option key={coll._id} value={coll._id}>
                      {coll.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <div className="ligneInputsCoverContainer">
                <span>Nb pages :&nbsp;</span>
                <input 
                    type='text' className='inputBook inputInCoverContainer'
                    placeholder='nombre' value={nbPages} onChange={(e) => setNbPages(e.target.value)} title='Nombre de pages'
                  />
              </div>

              <div className="ligneInputsCoverContainer">
                <span>Hauteur :&nbsp;</span>
                <input 
                    type='text' className='inputBook inputInCoverContainer'
                    placeholder='nombre' value={hauteur} onChange={(e) => setHauteur(e.target.value)} title='Hauteur'
                  />
              </div>

              <div className="ligneInputsCoverContainer">
                <span>Largeur :&nbsp;</span>
                <input 
                    type='text' className='inputBook inputInCoverContainer'
                    placeholder='nombre' value={largeur} onChange={(e) => setLargeur(e.target.value)} title='Largeur'
                  />
              </div>

              <div className="ligneInputsCoverContainer">
                <span>Poids :&nbsp;</span>
                <input 
                    type='text' className='inputBook inputInCoverContainer'
                    placeholder='nombre' value={poids} onChange={(e) => setPoids(e.target.value)} title='Poids'
                  />
              </div>

              <div className="ligneInputsCoverContainer">
                <span>Slogan :&nbsp;</span><textarea 
                    type='text' className='inputBook inputInCoverContainer'
                    placeholder='Slogan' value={catchphrase} onChange={(e) => setCatchphrase(e.target.value)} title='Slogan'
                    rows={3}
                  />
              </div>
            </div>
          </div>
          <div className="textColumn">
            <div controlId='title'>
              <input
                type='text'
                placeholder='Titre'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className='h1 inputBook'
                style={{ width: '100%', color: title ? '#333' : '#bb1122' }}
                title='Titre'
              />
            </div>

            <div controlId='subtitle'>
              <input
                type='text'
                placeholder='Sous-titre'
                value={subtitle}
                onChange={(e) => setSubtitle(e.target.value)}
                className='subtitle inputBook'
                style={{ width: '100%', color: subtitle ? '#222' : '#444' }}
                title='Sous-titre'
              />
            </div>

            <div className="ligneInputs">
              <div controlId='author1'>
                {loadingAuthors ? (
                  <Loader />
                ) : (
                  <>
                    <span style={{ color: author1 ? '#333' : '#bb1122' }}>Auteur 1 : </span><input
                      type="text"
                      value={author1}
                      onChange={(e) => {
                        const input = e.target.value;
                        setAuthor1(input);
                        const found = authorsList.find(
                          (author) => `${author.firstName} ${author.lastName}`.toLowerCase() === input.toLowerCase()
                        );
                        setAuthor1Id(found ? found._id : '');
                      }}
                      list="author-list"
                      placeholder="- Sélectionner un auteur -"
                      className="inputBook"
                      style={{ color: author1 ? '#111' : '#bb1122' }}
                    />
                    <datalist id="author-list">
                      {authorsList.map((author) => (
                        <option key={author._id} value={`${author.firstName} ${author.lastName}`} />
                      ))}
                    </datalist>
                  </>
                )}
              </div>
              <div controlId='author2'>
                {loadingAuthors ? (
                  <Loader />
                ) : (<>
                  Auteur 2 : <input
                    type="text"
                    value={author2}
                    onChange={(e) => {
                      const input = e.target.value;
                      setAuthor2(input);
                      const found = authorsList.find(
                        (author) => `${author.firstName} ${author.lastName}`.toLowerCase() === input.toLowerCase()
                      );
                      setAuthor2Id(found ? found._id : '');
                    }}
                    list="author-list"
                    placeholder="- Sélectionner un auteur -"
                    className="inputBook"
                  />
                  <datalist id="author-list">
                    {authorsList.map((author) => (
                      <option key={author._id} value={`${author.firstName} ${author.lastName}`} />
                    ))}
                  </datalist>                    
                </>)}
              </div>
            </div> 
            <div className="ligneInputs">
              <div controlId='translator'>
                {loadingAuthors ? (
                  <Loader />
                ) : (<>
                  Traduction : <input
                    type="text"
                    value={translator}
                    onChange={(e) => {
                      const input = e.target.value;
                      setTranslator(input);
                      const found = authorsList.find(
                        (author) => `${author.firstName} ${author.lastName}`.toLowerCase() === input.toLowerCase()
                      );
                      setTranslatorId(found ? found._id : '');
                    }}
                    list="author-list"
                    placeholder="- Sélectionner un auteur -"
                    className="inputBook"
                  />
                  <datalist id="author-list">
                    {authorsList.map((author) => (
                      <option key={author._id} value={`${author.firstName} ${author.lastName}`} />
                    ))}
                  </datalist>                    
                </>)}
              </div>
              <div controlId='language'>
                  Langue d'origine : <input
                    type="text"
                    placeholder="Langue d'origine"
                    value={language}
                    onChange={(e) => {
                      const input = e.target.value;
                      setLanguage(input);
                    }}
                    className="inputBook"
                  />
              </div>
              <div controlId='preface'>
                Préface de : <input 
                  type='text' className='inputBook' style={{ color: subtitle ? '#222' : '#444' }}
                  placeholder='Préfacier(ère)' value={preface} onChange={(e) => setPreface(e.target.value)} title='preface'
                />
              </div>
              <div controlId='illustrations'>
                Illustrations de : 
                <input 
                  type='text' className='inputBook' style={{ color: subtitle ? '#222' : '#444' }}
                  placeholder='Illustrateur(trice)' value={illustrations} onChange={(e) => setIllustrations(e.target.value)} title='illustrations'
                />
              </div>
            </div>

              
            <Tabs defaultActiveKey="description" className="mt-3">
              <Tab eventKey="description" title={
                  <span style={{ color: description ? '#333' : '#bb1122' }}>
                    Présentation
                  </span>
                }>
                <ReactQuill value={description} onChange={setDescription} className="auto-resize-quill"/>
              </Tab>
              <Tab eventKey="sommaire" title="Sommaire">
              <ReactQuill value={sommaire} onChange={setSommaire} className="auto-resize-quill"/>
              </Tab>
              <Tab eventKey="bonnepage" title="Bonne page">
              <ReactQuill value={bonnepage} onChange={setBonnepage} className="auto-resize-quill"/>
              </Tab>
            </Tabs>
          </div>
        </div>

        <Button type='submit' variant='primary' style={{ marginTop: '1rem' }}>
          Enregistrer les modifications
        </Button>


{/* 
        <div className="h1-adminContainer">
          <h1>Version formulaire</h1>
        </div>

        <Form.Group controlId='cover'>
          <Form.Label>Couverture</Form.Label>
          <Form.Control
            type='file'
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                const formData = new FormData();
                formData.append('cover', file);

                // Ajouter le fichier directement à l'état avant l'envoi
                setCover(formData);
                setPreviewUrl(URL.createObjectURL(file));
              }
            }}
          ></Form.Control>
        </Form.Group>
        
        <Form.Group controlId='title'>
          <Form.Label>Titre</Form.Label>
          <Form.Control
            type='text'
            placeholder='Saisir le titre'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='subtitle'>
          <Form.Label>Sous-titre</Form.Label>
          <Form.Control
            type='text'
            value={subtitle}
            onChange={(e) => setSubtitle(e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId='author2'>
          <Form.Label>Auteur 2</Form.Label>
          <Form.Control as='select' value={author2} onChange={(e) => setAuthor2(e.target.value)}>
            <option value=''>-- Aucun --</option>
            {authorsList.map((author) => (
              <option key={author._id} value={author._id}>
                {author.lastName}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Form.Group controlId='translator'>
          <Form.Label>Traducteur</Form.Label>
          <Form.Control as='select' value={translator} onChange={(e) => setTranslator(e.target.value)}>
            <option value=''>-- Aucun --</option>
            {authorsList.map((author) => (
              <option key={author._id} value={author._id}>
                {author.lastName}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        
        <Form.Group controlId="booksCollection">
          <Form.Label>Collection</Form.Label>
            <Form.Control
              as="select"
              value={booksCollection}
              onChange={(e) => setBooksCollection(e.target.value)}
              required
            >
              <option value="">Sélectionner une collection</option>
              {booksCollectionsList?.map((coll) => (
                <option key={coll._id} value={coll._id}>
                  {coll.name}
                </option>
              ))}
            </Form.Control>
        </Form.Group>

        <Form.Group controlId='preface'>
          <Form.Label>Préface</Form.Label>
          <Form.Control type='text' value={preface} onChange={(e) => setPreface(e.target.value)} />
        </Form.Group>

        <Form.Group controlId='illustrations'>
          <Form.Label>Illustrations</Form.Label>
          <Form.Control type='text' value={illustrations} onChange={(e) => setIllustrations(e.target.value)} />
        </Form.Group>

        <Form.Group controlId='bonnepage'>
          <Form.Label>Bonne page</Form.Label>
          <Form.Control type='text' value={bonnepage} onChange={(e) => setBonnepage(e.target.value)} />
        </Form.Group>

        <Form.Group controlId='sommaire'>
          <Form.Label>Sommaire</Form.Label>
          <Form.Control type='text' value={sommaire} onChange={(e) => setSommaire(e.target.value)} />
        </Form.Group>

        <Form.Group controlId='hauteur'>
          <Form.Label>Hauteur (cm)</Form.Label>
          <Form.Control type='number' step='0.1' value={hauteur} onChange={(e) => setHauteur(e.target.value)} />
        </Form.Group>

        <Form.Group controlId='largeur'>
          <Form.Label>Largeur (cm)</Form.Label>
          <Form.Control type='number' step='0.1' value={largeur} onChange={(e) => setLargeur(e.target.value)} />
        </Form.Group>

        <Form.Group controlId='poids'>
          <Form.Label>Poids (g)</Form.Label>
          <Form.Control type='number' step='1' value={poids} onChange={(e) => setPoids(e.target.value)} />
        </Form.Group>

        <Form.Group controlId='catchphrase'>
          <Form.Label>Slogan</Form.Label>
          <Form.Control
            type='text'
            placeholder='Saisir un slogan'
            value={catchphrase}
            onChange={(e) => setCatchphrase(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='price'>
          <Form.Label>Prix (€)</Form.Label>
          <Form.Control
            type='number'
            placeholder='Saisir le prix'
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='description'>
          <Form.Label>Description</Form.Label>
          <Form.Control
            as='textarea'
            placeholder='Saisir la description'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='isbn'>
          <Form.Label>ISBN</Form.Label>
          <Form.Control
            type='number'
            placeholder='Saisir l’ISBN'
            value={isbn}
            onChange={(e) => setIsbn(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='nbPages'>
          <Form.Label>Nombre de pages</Form.Label>
          <Form.Control
            type='number'
            placeholder='Saisir le nombre de pages'
            value={nbPages}
            onChange={(e) => setNbPages(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='countInStock'>
          <Form.Label>Quantité en stock</Form.Label>
          <Form.Control
            type='number'
            placeholder='Saisir la quantité en stock'
            value={stock}
            onChange={(e) => setStock(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='publicationDate'>
          <Form.Label>Date de publication</Form.Label>
          <Form.Control
            type='date'
            value={publicationDate}
            onChange={(e) => setPublicationDate(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='numeroEditeur'>
          <Form.Label>Numéro Editeur</Form.Label>
          <Form.Control
            type='number'
            value={numeroEditeur}
            onChange={(e) => setNumeroEditeur(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='inList'>
          <Form.Check
            type='checkbox'
            label='Afficher dans la liste ?'
            checked={inList}
            onChange={(e) => setInList(e.target.checked)}
          />
        </Form.Group>

        <Form.Group controlId='isVisible'>
          <Form.Label>Visibilité</Form.Label>
          <Form.Check
            type='checkbox'
            label='Visible'
            checked={isVisible}
            onChange={(e) => setIsVisible(e.target.checked)}
          ></Form.Check>
        </Form.Group>

        <Button type='submit' variant='primary' style={{ marginTop: '1rem' }}>
          Enregistrer les modifications
        </Button> */}
      </Form>
    </Container>
  );
};

export default BookEditScreen;
